import { render, staticRenderFns } from "./AttachmentBtnGroup.vue?vue&type=template&id=8472c2fe&scoped=true&"
import script from "./AttachmentBtnGroup.vue?vue&type=script&lang=js&"
export * from "./AttachmentBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentBtnGroup.vue?vue&type=style&index=0&id=8472c2fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8472c2fe",
  null
  
)

export default component.exports